import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTeamViewerLogo = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Ebene_1",
	"data-name": "Ebene 1",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 380.00023 380",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".cls-1{fill:#fff;}.cls-2{fill:#004680;}" }) }),
		/* @__PURE__ */ _jsx("circle", {
			className: "cls-1",
			cx: 190.00011,
			cy: 190,
			r: 170.29397
		}),
		/* @__PURE__ */ _jsx("polygon", {
			className: "cls-2",
			points: "152.503 136.723 138.43 170.901 241.956 170.901 227.883 136.723 333.035 190 227.883 243.277 241.956 209.099 138.43 209.099 152.391 243.277 46.966 190 152.503 136.723"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-2",
			d: "M357.73745,0H22.26255A22.328,22.328,0,0,0,0,22.26255v335.4749A22.328,22.328,0,0,0,22.26255,380h335.4749a22.32806,22.32806,0,0,0,22.26278-22.26255V22.26255A22.32806,22.32806,0,0,0,357.73745,0ZM190.00011,346.64571a156.64571,156.64571,0,1,1,156.64582-156.6456A156.64568,156.64568,0,0,1,190.00011,346.64571Z"
		})
	]
});
export default SvgTeamViewerLogo;
